export default __webpack_public_path__ + "static/media/logo-aberdeen-centre.0c5f0842.png";